import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { LinkColorLightTheme } from "../../../../Constant";
import { LINK_COLOR_DATA } from "../../../../Data/UiKit/Alert";
import { LightThemeLeftSection } from "./LightThemeLeftSection";
import LightThemeRightSection from "./LightThemeRightSection";

const LightTheme = () => {
  return (
    <Col xl="12">
      <Card>
        <CommonCardHeader title={LinkColorLightTheme} span={LINK_COLOR_DATA} />
        <CardBody>
          <Row>
            <LightThemeLeftSection />
            <LightThemeRightSection />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default LightTheme;
